module.exports = __webpack_public_path__ + "static/media/en-GB.d5ec29bd.md";